// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bfi_a bic_bk bic_bl bic_bo","SwipeLeftToClose--animating":"bfi_b"};